export default import.meta.ROLLDOWN_FILE_URL_2ZEzIIM_atdpHcr$6kvj$Q